import { useState, useEffect } from 'react';

export const useWindowWidth = (): [number] => {
  const [windowWidth, setWindowWidth] = useState<number>(window.innerWidth);
  useEffect(() => {
    const handleResize = (): void => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return [windowWidth];
};

export const useLocalStorageState = <T>(
  initialValue: T,
  localStorageKey: string
): [T, React.Dispatch<React.SetStateAction<T>>] => {
  const [state, setState] = useState<T>(
    JSON.parse(localStorage.getItem(localStorageKey) ?? 'null') ?? initialValue
  );

  useEffect(() => {
    localStorage.setItem(localStorageKey, JSON.stringify(state));
  }, [state, localStorageKey]);
  return [state, setState];
};
